import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { TokenService } from '../../services/token-service/token.service';
import { environment } from 'apps/rappider/src/environments/environment';
import { Store } from '@ngrx/store';
import { Logout } from '../../state/authentication.actions';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private tokenService: TokenService,
    private store: Store<any>,
  ) { }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    /* TODO: (canmustu) delete the api base url control and use this interceptor in rappider-api-sdk only */
    const isApiBaseUrl = request.url.startsWith(environment.apiBaseUrl);
    if (isApiBaseUrl) {
      /* get token key */
      const authenticationToken = this.tokenService.getAuthenticationToken();
      if (authenticationToken) {
        /* set authorization header by token key */
        request = request.clone({
          setHeaders: {
            Authorization: authenticationToken
          }
        });
      }
    }
    const response$ = next.handle(request);
    return response$.pipe(
      catchError(error => this.checkForTokenInvalidOrExpired(error, isApiBaseUrl))
    );
  }

  private checkForTokenInvalidOrExpired(error: HttpErrorResponse, isApiBaseUrl: boolean): Observable<never> {
    if (isApiBaseUrl && error.status === 401) {
      const words = error?.error?.error?.message;
      if (words?.includes('[ERR_TOKEN_INVALID]') || words?.includes('[ERR_TOKEN_EXPIRED]')) {
        this.store.dispatch(new Logout());
      }
    }

    return throwError(() => error);
  }
}
